import { TIMEZONES } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';
import { SelectInput, SelectProps } from '../../components/form/elements/select/SelectInput';

export type TimezoneSelectProps = Omit<SelectProps<string, any>, 'options' | 'value'> & {
  includeBrowser?: boolean;
  timezones?: string[];
};

export function TimezoneSelect(props: TimezoneSelectProps) {
  const { value, onChange, includeBrowser = true, timezones, ...rest } = props;

  const options = (includeBrowser ? [''] : [])
    .concat(timezones ? timezones.filter((tz) => TIMEZONES.includes(tz)) : TIMEZONES)
    .map((tz) => ({
      label: tz === '' ? 'Default (browser)' : tz,
      name: tz,
    })) as any;

  return (
    <SelectInput
      name="timezone"
      label={<FormattedMessage id="common.timezoneSelect.defaultLabel" defaultMessage="Timezone" />}
      {...rest}
      value={options.find((opt: any) => opt.name === value)!}
      options={options}
      getOptionLabel={(t) => t.label}
      getOptionValue={(t) => t.name!}
      onChange={(value: any) => {
        onChange(value.name);
      }}
    />
  );
}
